const contactValidationMessages = {
    'pl-PL': {
        missingValue: {
            default: 'Wymagane jest wypełnienie tego pola.',
            checkbox: 'To pole jest wymagane',
        },
        patternMismatch: {
            email: 'Wprowadzony adres e-mail jest nieprawidłowy.',
        }
    },
    'de-DE': {
        missingValue: {
            default: 'Dieses Feld muss ausgefüllt werden.',
            checkbox: 'Dieses Feld ist erforderlich',
        },
        patternMismatch: {
            email: 'Die eingegebene E-Mail-Adresse ist falsch.',
        }
    },
    'uk': {
        missingValue: {
            default: 'Це поле обов\'язкове для заповнення.',
            checkbox: 'Це поле обов\'язкове для заповнення',
        },
        patternMismatch: {
            email: 'Введена адреса електронної пошти є невірною.',
        }
    },
    'be': {
        missingValue: {
            default: 'Гэта поле абавязковае.',
            checkbox: 'Гэта поле абавязковае',
        },
        patternMismatch: {
            email: 'Уведзены няправільны адрас электроннай пошты.',
        }
    }
}

export default contactValidationMessages;